import { tracker } from './analytic';

// Wizard initialization
let $formSelector = $('form#reward_form_submission');
let redirect_url_brainacademy = $('.temp_information').data(
  'redirect-url-brainacademy',
);
$('#wizard').steps({
  headerTag: 'h3',
  bodyTag: 'section',
  transitionEffect: 'fade',
  saveState: true,
  titleTemplate:
    '<span class="number">#index#</span><span class="form-step-title">#title#</span>',
  labels: {
    cancel: 'Cancel',
    finish: 'Submit',
    next: 'Next',
    previous: 'Previous',
    loading: 'Loading...',
  },
  onStepChanging: function(event, currentIndex, newIndex) {
    if (newIndex > currentIndex) {
      $("label.validation-error-text").remove();
      showDataSummary();
      if (validateForm(currentIndex)) {
        return false;
      }
      return $formSelector.valid();
    }
    return true;
  },
  onFinishing: function(event, currentIndex) {
    return $formSelector.valid();
  },
  onFinished: function(event, currentIndex) {
    // Revalidate form before submit
    if (validateForm(currentIndex)) {
      return false;
    }

    let token = $(".user_identifier_value").val()
    Swal.fire({
      title: 'Are you sure to submit the data?',
      text: "Please recheck your data, it can't be changed once submitted!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Submit Data',
      cancelButtonText: 'Recheck Data',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Submitting data...');
        Swal.showLoading();
        let form_data = new FormData($formSelector[0]);
        $.ajax({
          type: 'POST',
          beforeSend: function(xhr) {
            if (token && token !== "") {
              xhr.setRequestHeader('Authorization', token);
            }
          },
          data: form_data,
          processData: false,
          contentType: false,
          url: $formSelector.attr('action'),
          success: function(result) {
            tracker("rgFormFormsSubmit", {})
            let data = result.data;
            if (data.redirect_url) {
              window.location = data.redirect_url;
            } else if (
              redirect_url_brainacademy !== '' &&
              redirect_url_brainacademy !== undefined
            ) {
              window.location =
                '/form/success?identifier_serial=' +
                data.identifier_serial +
                '&id=' +
                data.reward_form_id +
                '&redirect_url=' +
                redirect_url_brainacademy;
            } else {
              window.location =
                '/form/success?identifier_serial=' +
                data.identifier_serial +
                '&id=' +
                data.reward_form_id;
            }
          },
          error: function(data) {
            if (data.status === 403) return location.reload();

            Swal.close();
            let responseMessage =
              data.responseJSON === undefined
                ? 'Please check your internet connection and retry submitting the form.'
                : data.responseJSON.message;
            let message =
              data.status === 500 ? 'Internal Server Error' : responseMessage;
            Swal.fire({
              title: 'Failed to submit the data',
              text: message,
              icon: 'error',
              confirmButtonColor: '#763cb0',
              confirmButtonText: 'Close',
            });
            loadPrizeOption();
          },
        });
      }
    });
  },
  onStepChanged: function(event, currentIndex, priorIndex) {
    tracker("rgFormFormsShow", {
      stage_name: $(`#wizard-t-${currentIndex} .form-step-title`).text(),
      stage_number: currentIndex + 1,
    })
  },
});

if(window.location.pathname == '/form/success') {
  tracker("rgFormFormsShow", {
    stage_name: "success page"
  })
} else {
  // initial tracking step
  tracker("rgFormFormsShow", {
    stage_name: $(`#wizard-t-0 .form-step-title`).text(),
    stage_number: 1,
  })
}


function validateForm(index) {
  let isCheckBoxValid = validateChoiceGroup(index, 'checkbox') > 0;
  let isRadioValid = validateChoiceGroup(index, 'radio') > 0;
  let isFileValid = validateFileFields(index) > 0;
  let isPhoneValid = validatePhoneFields(index) > 0;

  return isCheckBoxValid || isRadioValid || isFileValid || isPhoneValid;
}
function showDataSummary() {
  let data = $('form#reward_form_submission')
    .find('.form-control')
    .serializeArray();

  let submissionSummary = '';
  $.each(data, function(index, value) {
    let $field = $('[name="' + value['name'] + '"]');
    let fieldId = $field.attr('id');
    if ($field.attr('data-dependent-field-visibility') === 'hidden') {
      return;
    }
    // Regex to remove all text with bracket from label
    let labelText = $('label[for=' + fieldId + ']')
      .text()
      .replace(/\([^()]*\)/g, '');
    let fieldSelectText = $('#' + fieldId + ' option:selected').text();
    let fieldValue = fieldSelectText === '' ? value['value'] : fieldSelectText;
    let fieldContent = fieldValue === '' ? '-' : htmlEncode(fieldValue);

    submissionSummary += `<p class="mb-1"><strong>${labelText}:</strong> ${fieldContent}</p>`;
  });

  let radioButtons = $('form#reward_form_submission').find('.input-radio');
  radioButtons.map(function() {
    if ($(this).find('label').attr('data-dependent-field-visibility') === 'hidden') {
      return;
    }

    if ($(this).prop('checked') === false) {
      return;
    }

    let selected_text = $(this)
      .parent()
      .text();
    let title = $(this).attr('data-title');

    submissionSummary += `<p class="mb-1"><strong>${title}:</strong> ${htmlEncode(
      selected_text,
    )}</p>`;
  });

  let checkboxes = $('form#reward_form_submission').find('div.checkbox-group');
  checkboxes.map(function() {
    if ($(this).find('label').attr('data-dependent-field-visibility') === 'hidden') {
      return;
    }

    let title = $(this).attr('data-title');
    let checkeds = $(this).find(':checkbox:checked');
    let checked_texts = [];
    checkeds.map(function() {
      checked_texts.push($(this).val());
    });
    submissionSummary += `<p class="mb-1"><strong>${title}:</strong> ${htmlEncode(
      checked_texts.join(', '),
    )}</p>`;
  });

  $('.submission-summary').html(submissionSummary);
}

function loadPrizeOption() {
  $("select[id^='reward_form_submission_submission_data_prize_options']").each(
    function() {
      const $select2Selector = $(this);
      const selectOptionName = $(this)
        .attr('id')
        .split('submission_data_')[1];
      $select2Selector.select2({
        theme: 'bootstrap',
        ajax: {
          type: 'get',
          url: '/api/v1/select_options?select_option_name=' + selectOptionName,
          dataType: 'json',
          data: function(params) {
            return {
              searchTerm: params.term, // search term
            };
          },
          processResults: function(data) {
            let optionData = data.data;
            return {
              results: $.map(optionData, function(item) {
                return {
                  text: item,
                  id: item,
                };
              }),
            };
          },
        },
      });
    },
  );
}

function validateChoiceGroup(currentIndex, fieldType) {
  let invalidate_choices = 0;
  let $choiceGroupRequireds = $('#wizard-p-' + currentIndex).find(
    `div.${fieldType}-group.is-required`,
  );
  $choiceGroupRequireds.map(function() {
    if ($(this).find(`:${fieldType}:checked`).length === 0) {
      let label = $(this).find('.form-label');
      let errorLabel = $(this).find('.validation-error-text');

      // Remove existing error label
      errorLabel.remove();

      // Add new error label
      label.after(
        "<label class='ml-1 text-danger validation-error-text'>This field is required.</label>",
      );
      invalidate_choices++;
    }
  });
  return invalidate_choices;
}

function validatePhoneFields(currentIndex) {
  let invalidate_phone_fields = 0;
  let $phonePrefixes = $('#wizard-p-' + currentIndex).find('.phone-prefix');
  $phonePrefixes.map(function() {
    if ($(this).prop('disabled')) return;
    if ($(this).prop('required') || $(this).val().length > 0) {
      let phone_prefix = $(this).data('phone-prefix');
      $(this)
        .prev('.prefix-invalid')
        .remove();
      $(this)
        .prev('.length-invalid')
        .remove();
      let prefix_valid = true;
      if (
        !$(this)
          .val()
          .startsWith(phone_prefix)
      ) {
        prefix_valid = false;
        $(this).before(
          `<label class='ml-1 prefix-invalid text-danger validation-error-text'>The phone number must be started with ${phone_prefix}</label>`,
        );
        invalidate_phone_fields++;
      }

      if (prefix_valid) {

        if ($(this).val().length <= phone_prefix.toString().length) {
          $(this).before(
            `<label class='ml-1 length-invalid text-danger validation-error-text'>Jumlah digit minimum tidak memenuhi kriteria</label>`,
          );
          invalidate_phone_fields++;
          return invalidate_phone_fields;
        }
      }
    }
  });
  return invalidate_phone_fields;
}

function validateFileFields(currentIndex) {
  let invalidate_file_fields = 0;
  let $fileRequireds = $('#wizard-p-' + currentIndex).find('div.file-required');
  $fileRequireds.map(function() {
    if ($(this).find('.form-control-file')[0].files.length == 0) {
      let label = $(this).find('label.required');
      label.after(
        "<label class='ml-1 text-danger validation-error-text'>This field is required.</label>",
      );
      invalidate_file_fields++;
    }
  });
  return invalidate_file_fields;
}

function htmlEncode(str) {
  return String(str).replace(/[^\w. ]/gi, function(c) {
    return '&#' + c.charCodeAt(0) + ';';
  });
}


